<template>
  <div class="vote_con">
    <div class="vote_box" v-if="loadSuccess">
      <span class="title"
        >{{ voteInfo.title
        }}{{
          !isEnd
            ? voteInfo.canVoteNum > 1
              ? `（最多选${voteInfo.canVoteNum}项）`
              : '（单选）'
            : ''
        }}</span
      >
      <div class="info_line">
        <span class="time">{{ voteInfo.time }}</span>
        <span class="people">{{ voteInfo.peopleNum }} 人参与</span>
      </div>
      <van-radio-group
        v-model="radio"
        v-if="voteInfo.canVoteNum == 1 && !isEnd"
      >
        <van-cell-group>
          <van-cell
            :title="item.text"
            clickable
            @click="radio = item.id"
            v-for="(item, index) in list"
            :key="index"
          >
            <template #right-icon>
              <van-radio :name="item.id" :checked-color="checkedColor" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <van-checkbox-group
        v-model="result"
        :max="voteInfo.canVoteNum"
        v-if="voteInfo.canVoteNum > 1 && !isEnd"
      >
        <van-cell-group>
          <van-cell
            v-for="(item, index) in list"
            clickable
            :key="index"
            :title="`${item.text}`"
            @click="toggle(index)"
          >
            <template #right-icon>
              <van-checkbox
                :name="item.id"
                :checked-color="checkedColor"
                ref="checkboxes"
              />
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
      <div class="vote_result" v-if="isEnd">
        <div class="vote_item" v-for="(item, index) in list" :key="index">
          <div class="select_info">
            <span>{{ item.text }}</span>
            <van-icon
              v-if="item.isGeted"
              name="success"
              :color="checkedColor"
              size=".36rem"
            />
          </div>
          <div class="vote_info">
            <span>{{ item.num }} 票</span>
            <span>{{ item.percentage }}%</span>
          </div>
          <van-progress
            :percentage="item.percentage"
            stroke-width="6"
            :show-pivot="false"
            :color="checkedColor"
          />
        </div>
      </div>
      <div
        v-if="!isEnd && (radio || result.length != 0)"
        class="vote_btn"
        :style="`background-color:${checkedColor}`"
        @click="vote"
      >
        投票
      </div>
      <div
        class="vote_btn_no"
        v-if="!isEnd && radio == '' && result.length == 0"
      >
        投票
      </div>
    </div>
    <span v-else>投票加载失败</span>
  </div>
</template>

<script>
import { debounce } from 'lodash';
import qs from 'qs';
import get from '@/api/get';
import { Toast } from 'vant';
export default {
  name: 'vote',
  props: ['voteid'],
  components: {},
  data() {
    return {
      loadSuccess: true,
      radio: '', //单选结果
      result: [], //多选结果
      checkedColor: '', //主题颜色
      isEnd: false, //截止或者投过
      list: [
        // {
        //   id:'',
        //   text:'',
        //   num:'',
        //   isGeted:false
        //   percentage:'10%'
        // }
      ],
      voteInfo: {
        title: '',
        time: '',
        peopleNum: 0,
        canVoteNum: 1
      }
    };
  },
  computed: {},
  watch: {},
  methods: {
    vote: debounce(
      function () {
        if (this.$store.state.loginStatus == 1) {
          let params = {};
          if (this.voteInfo.canVoteNum == 1) {
            params.voteOptions = [this.radio];
          } else {
            params.voteOptions = this.result.join();
          }
          get.getVote(this.voteid, qs.stringify(params)).then((res) => {
            console.log(res);
            if (res.data.code == 0) {
              this.init();
            } else {
              Toast(`投票失败，请稍后再试--code:${res.data.code}`);
            }
          });
        } else {
          this.$store.commit('changeLoginShow', true);
        }
      },
      2000,
      {
        leading: true,
        trailing: false
      }
    ),
    init() {
      get.getVoteInfo(this.voteid).then((res) => {
        if (res.data.code == 0) {
          this.voteInfo.title = res.data.data.info.voteName;
          if (new Date().getTime() > res.data.data.info.endTime) {
            this.voteInfo.time = '投票已截止';
            this.isEnd = true;
          } else {
            let date = new Date(res.data.data.info.endTime);
            let Y = date.getFullYear() + '-';
            let M =
              (date.getMonth() + 1 < 10
                ? '0' + (date.getMonth() + 1)
                : date.getMonth() + 1) + '-';
            let D =
              (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) +
              ' ';
            let h =
              (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) +
              ':';
            let m =
              (date.getMinutes() < 10
                ? '0' + date.getMinutes()
                : date.getMinutes()) + '';
            let s =
              date.getSeconds() < 10
                ? '0' + date.getSeconds()
                : date.getSeconds();
            let formattedTime = Y + M + D + h + m;
            this.voteInfo.time = formattedTime + ' 截止';
          }
          this.voteInfo.peopleNum = res.data.data.info.voteMembersNum;
          if (this.voteInfo.peopleNum >= 10000) {
            this.voteInfo.peopleNum =
              (this.voteInfo.peopleNum / 10000).toFixed(1) + '万';
          }
          this.voteInfo.canVoteNum = res.data.data.info.voteMaxNum;
          this.list = res.data.data.options.map((item, index) => {
            if (item.memberId) {
              this.isEnd = true;
            }
            return {
              id: item.id,
              text: item.voteOption,
              num: res.data.data?.nums
                ? res.data.data.nums[item.id]
                  ? res.data.data.nums[item.id]
                  : 0
                : 0,
              isGeted: item.memberId ? true : false
            };
          });
          if (this.isEnd) {
            let totalNum = this.list.reduce(
              (total, item) => total + item.num,
              0
            );
            this.list.forEach((item) => {
              if (item.num == 0) {
                item.percentage = 0;
              } else {
                item.percentage = ((item.num / totalNum) * 100).toFixed(2);
                if (item.percentage == '100.00') {
                  item.percentage = '100';
                }
              }
            });
          }
        } else {
          this.loadSuccess = false;
        }
      });
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    }
  },
  created() {
    this.init();
    switch (this.$store.state.gameType) {
      case 1:
        this.checkedColor = '#2c89f1';
        break;
      case 2:
        this.checkedColor = '#18232c';
        break;
      case 3:
        this.checkedColor = '#00d4a5';
        break;
      case '4':
        break;
      case '5':
    }
  },
  mounted() {}
};
</script>
<style lang='scss' scoped>
.vote_con {
  border-radius: 0.16rem;
  background-color: #f8f8f8;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.vote_box {
  padding: 0.3rem 0.5rem;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    width: 100%;
    color: #000;
    font-size: 0.32rem;
  }
  .info_line {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .time,
    .people {
      color: #767676;
      font-size: 0.22rem;
    }
  }
  .van-radio-group,
  .van-checkbox-group {
    width: 100%;
    .van-cell-group {
      width: 100%;
      background-color: #f5f5f5;
      .van-cell {
        margin-top: 0.2rem;
        border-radius: 0.12rem;
        .van-cell__title {
          font-size: 0.26rem;
          color: #767676;
        }
      }
    }
  }
  .vote_result {
    width: 100%;
    display: flex;
    flex-direction: column;
    .vote_item {
      width: 100%;
      display: flex;
      flex-direction: column;
      margin-top: 0.16rem;
      .select_info {
        width: 100%;
        display: flex;
        align-items: center;
        span {
          font-size: 0.28rem;
          color: #767676;
        }
      }
      .vote_info {
        margin-bottom: 0.06rem;
        width: 100%;
        display: flex;
        justify-content: space-between;
        span {
          font-size: 0.22rem;
          color: #767676;
        }
      }
    }
    .vote_item:nth-child(1) {
      margin-top: 0;
    }
  }
  .vote_btn {
    width: 100%;
    height: 0.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.28rem;
    color: #fff;
    margin-top: 0.3rem;
    border-radius: 0.12rem;
  }
  .vote_btn_no {
    width: 100%;
    height: 0.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.28rem;
    color: #fff;
    margin-top: 0.3rem;
    border-radius: 0.12rem;
    background-color: #cbcbcb;
  }
}
.ipad .vote_box {
  .vote_btn,
  .vote_btn_no {
    height: 0.86rem;
  }
}
</style>